import React  from "react";
import { Form, Col } from "react-bootstrap";
import { ApplicantContainer} from "../unstated/applicant";
import { Fragment } from "react";

export default function MusicBackground() {
    
    let app = ApplicantContainer.useContainer();

    let inputMusicBackground = app.inStdValues.frMusic;

      const addMusicBackground = index => {    

        const values = [...inputMusicBackground];
        values.splice(index+1, 0, { InstrumentPlayed: '', MusicGrade: '' });
       
        app.onChangeInStdValues({...app.inStdValues, frMusic:values});
      }

      const delMusicBackground = index => {    

        if(inputMusicBackground.length === 1) return 0;

        const values = [...inputMusicBackground];    
        values.splice(index, 1);

        if(values.length === 1) values[0].highest = true;       

        app.onChangeInStdValues({...app.inStdValues, frMusic:values});
      }

      const handleInputChange = (inputname, index, event) => {        
        const values = [...inputMusicBackground];  
        
        values[index].[inputname] = event.target.value;    
  
        app.onChangeInStdValues({...app.inStdValues, frMusic:values});
      };

    return (
        
    app.showMusicBackground ? 
        <>
        <Form.Row className="d-none d-sm-flex ">
          
            <Col xs={12} sm={5} className="table-header d-flex justify-content-center mx-auto">            
            <Form.Group as={Col}>
              <Form.Label>Instrument Played</Form.Label>
            </Form.Group>
            </Col>
            <Col xs={12} sm={5} className="table-header d-flex justify-content-center mx-auto">            
            <Form.Group as={Col}>
            <Form.Label>Qualification / Grade Level</Form.Label>
            </Form.Group>
            </Col>        
            <Col xs={12} sm={2} className="table-header d-flex justify-content-center">                      
            <Form.Group as={Col} className="segbutton">
            <Form.Label>action</Form.Label>
            </Form.Group>
            </Col>        
            
      </Form.Row> 


        {inputMusicBackground.map((inputField, index) => (      
            <Fragment key={`${inputField}~${index}`}>
            <Form.Row >
                <Col xs={12} sm={5}>
                <Form.Group as={Col} controlId="frInstrumentPlayed[]">
                    <Form.Label className="d-flex d-sm-none">Instrument Played</Form.Label>
                    <Form.Control type="text" required name="frInstrumentPlayed" placeholder="" value={inputField.InstrumentPlayed} onChange={event => handleInputChange('InstrumentPlayed', index, event)} />
                </Form.Group>
                </Col>
                <Col xs={12} sm={5}>
                <Form.Group as={Col} controlId="frMusicGrade[]">
                    <Form.Label className="d-flex d-sm-none">Qualification / Grade Level</Form.Label>
                    <Form.Control type="text" required name="frMusicGrade" placeholder="" value={inputField.MusicGrade} onChange={event => handleInputChange('MusicGrade', index, event)} />
                </Form.Group>
                </Col>             
                <Col xs={12} sm={2} md={2} lg={2} className="d-flex justify-content-center">
                  <Form.Group as={Col} controlId="formQualificationAdd[]" className="segbutton">
                    <Form.Control type="button" className="add btn btn-outline-primary" value="+" onClick={() => addMusicBackground(index)} />&nbsp;
                  </Form.Group>  
                  <Form.Group as={Col} controlId="formQualificationDel[]" className="segbutton">
                    <Form.Control type="button" className="del btn btn-outline-danger" value="-" onClick={() => delMusicBackground(index)} />
                  </Form.Group>
                </Col>                         
            </Form.Row> 
            <hr className="d-flex d-sm-none" /> 
            </Fragment>
        ))}
        </>
        : <></> 

    );
}